export const diaperSkus = [
  2378, 2379, 2380, 2381, 3149, 3150, 3151, 3152, 3483, 3484, 3485, 3486, 3839,
  3840, 3841, 3842, 3459, 3725, 3742, 1694, 1691, 1697, 3909, 3917, 3920, 3930,
  3931, 3932,
];

export const cdSkus = [
  506, 507, 969, 505, 508, 504, 967, 968, 970, 3878, 3928, 3929,
];

export const elementPresentInCart = (data) => {
  const skusInCart = data?.data?.cart_products.map((element) => element?.id);
  let x = skusInCart;
  if (data?.data?.cart_products[0]?.offered_product?.length) {
    const productsOffered = data?.data?.cart_products[0]?.offered_product?.map(
      (product) => {
        return product.id;
      },
    );
    x = x?.concat(productsOffered);
  }
  if (x)
    for (const ele of x) {
      if (diaperSkus?.indexOf(ele) !== -1 || cdSkus?.indexOf(ele) !== -1) {
        return true;
      }
    }
};

export const isShipRocketGatewayEligible = (userType) => {
  return false;
};

export const maternitySkusList = [
  2019, 2020, 2021, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032,
  2035, 2036, 2037, 2039, 2040, 2041, 2042, 2061, 2062, 2063, 2064, 2065, 2066,
  2067, 2068, 2071, 2072, 2073, 2074, 2075, 2076, 2077, 2078, 2079, 2080, 2081,
  2082, 2231, 2239, 2252, 2253, 2254, 2255, 2258, 2370, 2371, 2372, 2373, 2374,
  2376, 2419, 2421, 2422, 2840, 2842, 2843, 2844, 2846, 2848, 2851,
];

export const maternityVariantData = [
  {
    title: 'Dress',
    product_id: 2075,
    image:
      'https://images.myloapp.in/skuImages/2075/Listing/App/EN/Slide_1.webp',
    web_url:
      '/product/maternity-dresses-for-women-with-both-side-zipper-for-easy-feeding-adjustable-belt-for-growing-belly-2075',
    TYPE: 'Dress',
  },
  {
    title: 'Kaftan',
    product_id: 2064,
    image:
      'https://images.myloapp.in/skuImages/2064/Listing/App/EN/Slide_1.webp',
    web_url:
      '/product/pre-post-maternity-nursing-kaftan-maxi-dress-cum-nighty-with-both-sides-zipper-shibori--fuchsiaxxl-2064',
    TYPE: 'Kaftan',
  },
  {
    title: 'Midi',
    product_id: 2842,
    image:
      'https://images.myloapp.in/skuImages/2842/Listing/App/EN/slide_2.webp',
    web_url:
      '/product/pre-post-maternity-nursing-knee-length-dress-with-both-sides-zipper-for-easy-feeding-teal-green-vint-2842',
    TYPE: 'Midi',
  },
];

export const maternityBraSkuList = [
  1055, 1027, 1331, 1345, 1938, 1782, 1944, 1042, 1056, 1028, 1318, 1332, 1339,
  1353, 1325, 2645, 3056, 3062, 1939, 1043, 1836, 1792, 1029, 1319, 1333, 1340,
  1354, 2646, 3057, 3063, 1952, 1051, 1940, 1044, 1837, 1320, 1334, 1348, 1341,
  1355, 2641, 3058, 1024, 1941, 1045, 1838, 1321, 1335, 1349, 1342, 1356, 2648,
  3059, 3065, 1539, 1025, 1954, 1942, 1046, 1948, 1797, 1322, 1336, 1343, 1357,
  2643, 2649, 1540, 1026, 1780, 1955, 1054, 1789, 1047, 1061, 1828, 1323, 1337,
  1351, 1358, 2650, 3061, 3067, 1048, 1034,
];

export const maternityDresses = [
  1950, 3547, 854, 853, 852, 1699, 1700, 1698, 747, 746, 2960, 2203, 2202, 2204,
  2205, 2959, 2961, 2958, 1952, 1955, 1949, 1938, 1939, 1940, 1941, 1942, 1943,
  1960, 1956, 1961, 1539, 1540, 1835, 1829, 1823, 1830, 1824, 1831, 1825, 1832,
  1826, 1833, 1827, 1834, 1828, 1842, 1844, 1841, 3056, 3057, 3058, 3059, 3061,
  3063, 2641, 3065, 2643, 3067, 3062, 2645, 2646, 2648, 2649, 2650, 1782, 1791,
  1773, 1774, 1784, 1512, 1776, 1785, 1513, 1777, 1786, 1796, 1779, 1788, 1515,
  1780, 1798, 1789, 1792, 1797, 1805, 1808, 1810, 1811, 1814, 1816, 1799, 1800,
  1801, 1802, 1803, 1804, 1820, 1822, 1817, 1319, 1320, 1321, 1323, 1331, 1322,
  1325, 1334, 1356, 1357, 1358, 1345, 1348, 1349, 1351, 1336, 1332, 1333, 1335,
  1337, 1339, 1340, 1341, 1342, 1343, 1353, 1354, 1355, 1048, 1055, 1027, 1034,
  1041, 1056, 1021, 1042, 1028, 1029, 1043, 1044, 1024, 1045, 1046, 1025, 1026,
  1033, 1054, 1047, 1061, 1318, 1006, 1363, 1367, 1012, 1368, 1014, 1018, 1019,
  1375, 1005, 1362, 1007, 1364, 1008, 1365, 1009, 1366, 1010, 1013, 1369, 1370,
  1015, 1371, 1016, 1372, 1017, 1373, 612, 2400, 2402, 611, 610, 613, 614, 616,
  2399, 2401, 2062, 2061, 2063, 2064, 2258, 2066, 2065, 2067, 2068, 2253, 2252,
  2254, 2255, 2257, 2256, 2259, 2024, 2023, 2025, 2026, 2020, 2019, 2021, 2018,
  2016, 2015, 2017, 2022, 2032, 2031, 2028, 2027, 2029, 2030, 2033, 2034, 2040,
  2039, 2041, 2042, 2036, 2035, 2037, 2038, 2072, 2071, 2073, 2074, 2076, 2075,
  2077, 2078, 2080, 2079, 2081, 2082, 2230, 2231, 2239, 2237, 2240, 2246, 2245,
  2247, 2248, 2242, 2241, 2243, 2244, 2374, 2376, 2371, 2370, 2372, 2373, 2375,
  2377, 2422, 2419, 2421, 2848, 2851, 2845, 2844, 2846, 2840, 2842, 2843, 2849,
  2198, 2194, 2954, 2974, 2976, 2977, 2975,
];
